export default __webpack_public_path__ + "static/media/create-nav-systems-img.ce1947b7.jpg";